import { useState } from 'react';
import { useFeatureFlags, useUpsertFlag } from '../lib/queries.js';

export function FlagsPage() {
  const { data } = useFeatureFlags();
  const upsert = useUpsertFlag();
  const [newKey, setNewKey] = useState('');

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">Feature flags</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!newKey) return;
          upsert.mutate({ key: newKey, enabledGlobally: false });
          setNewKey('');
        }}
        className="mb-4 flex gap-2"
      >
        <input
          value={newKey}
          onChange={(e) => setNewKey(e.target.value)}
          placeholder="key (ex.: beta.realtime)"
          className="flex-1 rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2 text-sm font-mono"
        />
        <button type="submit" className="rounded-md bg-zinc-800 px-4 text-sm hover:bg-zinc-700">
          Criar
        </button>
      </form>
      <div className="rounded-lg border border-zinc-800 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-xs uppercase text-zinc-500">
            <tr>
              <th className="text-left py-2 px-3">Key</th>
              <th className="text-left">Global</th>
              <th className="text-left">Plans</th>
              <th className="text-left">Workspaces</th>
              <th className="text-left">Rollout %</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data?.flags.map((f) => (
              <tr key={f.id} className="border-t border-zinc-800/50">
                <td className="py-2 px-3 font-mono text-xs">{f.key}</td>
                <td>
                  <span className={f.enabledGlobally ? 'text-emerald-400' : 'text-zinc-500'}>
                    {f.enabledGlobally ? 'on' : 'off'}
                  </span>
                </td>
                <td className="text-xs text-zinc-400">{f.enabledPlans.join(', ') || '—'}</td>
                <td className="text-xs text-zinc-400">{f.enabledWorkspaces.length} workspaces</td>
                <td className="text-xs text-zinc-400">{f.rolloutPercentage ?? '—'}</td>
                <td className="text-right">
                  <button
                    onClick={() => upsert.mutate({ key: f.key, enabledGlobally: !f.enabledGlobally })}
                    className="text-xs text-cyan-400 hover:underline px-2"
                  >
                    toggle global
                  </button>
                </td>
              </tr>
            ))}
            {data?.flags.length === 0 && (
              <tr>
                <td colSpan={6} className="py-6 text-center text-zinc-500">
                  sem flags
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
